// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const orderRouter =
{
  path:  roterPre+`/order`,
  name: 'order',
  meta: {
    icon: 'dashboard',
    title: '订单'
  },
  alwaysShow: true,
  component: Layout,
  redirect: 'noRedirect',
  children: [
    {
      path: 'list',
      name: 'OrderList',
      meta: {
        title: '订单管理'
      },
      component: () => import('@/views/order/index.vue')
    },
    {
      path: 'refund',
      name: 'OrderRefund',
      meta: {
        title: '退款单'
      },
      component: () => import('@/views/order/orderRefund/index.vue')
    },
    {
      path: 'invoice',
      name: 'OrderInvoice ',
      meta: {
        title: '发票管理'
      },
      component: () => import('@/views/order/orderInvoice/index.vue')
    },
    {
      path: 'cancellation',
      name: 'OrderCancellation',
      meta: {
        title: '核销订单'
      },
      component: () => import('@/views/order/orderCancellate/index.vue')
    },
    {
      path: 'verifyRecord',
      name: 'VerifyRecord',
      meta: {
        title: '次卡核销记录'
      },
      component: () => import('@/views/order/verifyRecord/index.vue')
    },
    {
      path: 'deliveryOrder',
      name: 'DeliveryOrder',
      meta: {
        title: '同城配送订单'
      },
      component: () => import('@/views/order/deliveryOrder/index.vue')
    },
    {
      path: 'print',
      name: `OrderPrint`,
      meta: {
        title: '配货单打印',
        fullScreen: true,
      },
      component: () => import('@/views/order/print/index.vue'),
    },
    {
      path: 'customer',
      name: `CustomerOrder`,
      meta: {
        title: '代客下单',
        fullScreen: true,
      },
      component: () => import('@/views/customerOrder/index.vue'),
    },
    {
      path: 'reservation',
      name: `Reservation`,
      meta: {
        title: '预约服务',

      },
      component: () => import('@/views/order/orderReservation/index.vue'),
    },
  ]
}

export default orderRouter as RouteRecordRaw